/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GuideDeleteResponseData } from "./GuideDeleteResponseData";
export const GuideDeleteResponse = core.serialization.object({
    data: GuideDeleteResponseData,
});
